/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SendTransactionAuthorizationRequestRequest
 */
export interface SendTransactionAuthorizationRequestRequest {
    /**
     * 
     * @type {string}
     * @memberof SendTransactionAuthorizationRequestRequest
     */
    'paymentReferenceId': string;
    /**
     * 
     * @type {string}
     * @memberof SendTransactionAuthorizationRequestRequest
     */
    'usage': SendTransactionAuthorizationRequestRequestUsageEnum;
    /**
     * 
     * @type {string}
     * @memberof SendTransactionAuthorizationRequestRequest
     */
    'usageDetail'?: string | null;
}

export const SendTransactionAuthorizationRequestRequestUsageEnum = {
    stocking: 'STOCKING',
    gift: 'GIFT',
    businessNecessity: 'BUSINESS_NECESSITY',
    advertisement: 'ADVERTISEMENT',
    travel: 'TRAVEL',
    softwareUsageFee: 'SOFTWARE_USAGE_FEE'
} as const;

export type SendTransactionAuthorizationRequestRequestUsageEnum = typeof SendTransactionAuthorizationRequestRequestUsageEnum[keyof typeof SendTransactionAuthorizationRequestRequestUsageEnum];


